import React from 'react';
import Typography from '@mui/material/Typography';
import {To, useNavigate} from "react-router-dom";
import './Products.css'

const Products = () => {

    const navigate = useNavigate();
    const handleNavigation = (path: To) => {
        navigate(path);
        window.scrollTo(0, 0);
    };

    return (
        <div className='products-container'>
            <div className="card card-1">
                <div className="card-content">
                    <Typography sx={{
                        color: '#ffffff',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '27px',
                        '@media (max-width: 430px)': {
                            fontSize: '24px',
                        },
                        fontWeight: 500,
                        marginLeft: '9px'
                    }}>
                        Seguro de salud
                    </Typography>
                    <button className="product-card-btn" onClick={() => handleNavigation('/Portafolio/Seguro-de-salud')}>
                        <p>Detalles</p>
                        <svg strokeWidth="4" stroke="currentColor" viewBox="0 0 24 24" fill="none"
                             className="h-6 w-6" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 5l7 7m0 0l-7 7m7-7H3" strokeLinejoin="round"
                                  strokeLinecap="round"></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div className="card card-2">
                <div className="card-content">
                    <Typography sx={{
                        color: '#ffffff',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '27px',
                        '@media (max-width: 430px)': {
                            fontSize: '24px',
                        },
                        fontWeight: 500,
                        marginLeft: '9px'
                    }}>
                        Áreas comunes
                    </Typography>
                    <button className="product-card-btn" onClick={() => handleNavigation('/Portafolio/Areas-comunes')}>
                        <p>Detalles</p>
                        <svg strokeWidth="4" stroke="currentColor" viewBox="0 0 24 24" fill="none"
                             className="h-6 w-6" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 5l7 7m0 0l-7 7m7-7H3" strokeLinejoin="round"
                                  strokeLinecap="round"></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div className="card card-3">
                <div className="card-content">
                    <Typography sx={{
                        color: '#ffffff',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '27px',
                        '@media (max-width: 430px)': {
                            fontSize: '24px',
                        },
                        fontWeight: 500,
                        marginLeft: '9px'
                    }}>
                        Transporte de carga
                    </Typography>
                    <button className="product-card-btn" onClick={() => handleNavigation('/Portafolio/Transporte-de-carga')}>
                        <p>Detalles</p>
                        <svg strokeWidth="4" stroke="currentColor" viewBox="0 0 24 24" fill="none"
                             className="h-6 w-6" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 5l7 7m0 0l-7 7m7-7H3" strokeLinejoin="round"
                                  strokeLinecap="round"></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div className="card card-4">
                <div className="card-content">
                    <Typography sx={{
                        color: '#ffffff',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '27px',
                        '@media (max-width: 430px)': {
                            fontSize: '24px',
                        },
                        fontWeight: 500,
                        marginLeft: '9px'
                    }}>
                        Todo riesgo pesados
                    </Typography>
                    <button className="product-card-btn" onClick={() => handleNavigation('/Portafolio/Todo-riesgo-pesados')}>
                        <p>Detalles</p>
                        <svg strokeWidth="4" stroke="currentColor" viewBox="0 0 24 24" fill="none"
                             className="h-6 w-6" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 5l7 7m0 0l-7 7m7-7H3" strokeLinejoin="round"
                                  strokeLinecap="round"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Products;
